import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesSupply {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.Client.PageName == "Supply") {
            //报缺货
            if (webcontext.ConfigName == "TBBaoXiaoLiangXML" && webcontext.OpType.toLowerCase() == "add") {
                webcontext.ConfigName = "TBShangBaoQueHuoXML";
                webcontext.RequestBody = this.formateData(webcontext.RequestBody);
                console.log(webcontext);
            }
        }
        return webcontext;
    }

    private formateData(data: string): string {
        let res = JSON.parse(data);
        let arr: Array<any> = new Array<any>();
        let resItem: Object;
        res.forEach((item, i) => {
            resItem = {
                'a_GroupingName': item.a_GroupingName,
                'a_title': item.a_title,
                'a_kucun': item.a_kucun,
                'a_BuHuoLiang': item.a_BuHuoLiang
            }
            arr.push(resItem);
        })
        return JSON.stringify(arr);
    }


    public ContextBeforeChangeValue(webcontext: any, ConfigName: string): any {
        if (ConfigName == "Supply") {
          
        }
        return webcontext;
      }

}